import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { resynchronise } from "@/api/graphql/migration/resynchronize/api";
import { ResynchroniseParams } from "@/api/graphql/migration/resynchronize/types";
import { useAddSnackbar } from "@/contexts/snackbar";

export const useResynchroniseContracts = (close: () => void) => {
  const addSnackbar = useAddSnackbar();
  const { t } = useTranslation("migrationReport");

  const { mutateAsync, isSuccess, error, isPending } = useMutation({
    mutationFn: async ({
      customerAccountNumbers,
      type,
    }: ResynchroniseParams) => {
      const response = await resynchronise({
        type,
        customerAccountNumbers,
      });

      return response.MiddleMsResynchronisation;
    },
    onSuccess: () => {
      close();
      addSnackbar({
        title: t("migrationReport.drawer.sync.success.title"),
        message: t("migrationReport.drawer.sync.success.message"),
        dataTestId: "migration-report__success-snackbar",
        type: "success",
        isAutoClose: true,
      });
    },
    onError: () => {
      addSnackbar({
        dataTestId: "migration-report__error-snackbar",
        title: t("migrationReport.drawer.sync.error.title"),
        message: t("migrationReport.drawer.sync.error.message"),
        type: "error",
        isAutoClose: true,
      });
    },
  });

  return {
    mutateAsync,
    isSuccess,
    error,
    isPending,
  };
};
